import React from 'react';
import PropTypes from 'prop-types';
import useStyles from './iconCustomSVG.styles';
/* eslint no-tabs: ['error', { allowIndentationTabs: true }] */

const DEFAULT_ICON_SIZE = 53;

const IconVibrantSVG = (props) => {
        const {
                backgroundColor,
        } = props;
        const classes = useStyles({
                backgroundColor,
        });

        return (
                <svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px'
                        viewBox='-0.5 -0.5 48.8 49' xmlSpace='preserve'>
                        <g>
                        	<circle className={classes.st0} cx='23.9' cy='24.1' r='23.4' />
                        </g>
            			<g transform='translate(7 12.5) scale(0.075)'>
							<defs>
								<linearGradient id='ecalLoadingGrad1' x1='99.12' y1='54.1' x2='426.64' y2='53.52' gradientUnits='userSpaceOnUse'>
									<stop offset='0' stopColor='#ff9e00' />
									<stop offset='1' stopColor='#ff4c00' />
								</linearGradient>
								<linearGradient id='ecalLoadingGrad2' x1='-19860.28' y1='54.12' x2='-19497.81' y2='53.48' gradientTransform='translate(11289.25 107.61) scale(0.56 -1)' gradientUnits='userSpaceOnUse'>
									<stop offset='0' stopColor='#ff9e00' />
									<stop offset='1' stopColor='#ffe000' />
								</linearGradient>
								<linearGradient id='ecalLoadingGrad3' x1='2.65' y1='161.67' x2='290.7' y2='161.16' gradientUnits='userSpaceOnUse'>
									<stop offset='0' stopColor='#00d7ff' />
									<stop offset='0.16' stopColor='#00c6ff' />
									<stop offset='1' stopColor='#0074ff' />
								</linearGradient>
								<linearGradient id='ecalLoadingGrad4' x1='51.86' y1='161.42' x2='257.92' y2='161.42' gradientTransform='translate(309.78 322.83) rotate(180)' gradientUnits='userSpaceOnUse'>
									<stop offset='0' stopColor='#00d6ff' />
									<stop offset='0.53' stopColor='#00d5a2' />
									<stop offset='1' stopColor='#00d54f' />
								</linearGradient>
								<linearGradient id='ecalLoadingGrad5' x1='44.77' y1='269.3' x2='376.03' y2='268.72' gradientUnits='userSpaceOnUse'>
									<stop offset='0' stopColor='#000084' />
									<stop offset='1' stopColor='#0074ff' />
								</linearGradient>
								<linearGradient id='ecalLoadingGrad6' x1='132.56' y1='269.01' x2='380.78' y2='269.01' gradientTransform='translate(513.34 538.02) rotate(-180)' gradientUnits='userSpaceOnUse'>
									<stop offset='0' stopColor='#0074ff' />
									<stop offset='1' stopColor='#000084' />
								</linearGradient>
							</defs>
							<rect style={{ fill: 'url(#ecalLoadingGrad1)' }} x='96.11' y='0' width='335.23' height='107.61' rx='53.81' ry='53.81' />
							<rect style={{ fill: 'url(#ecalLoadingGrad2)' }} x='180.23' y='0' width='207.49' height='107.61' rx='53.81' ry='53.81' transform='translate(567.94 107.61) rotate(180)' />
							<rect style={{ fill: 'url(#ecalLoadingGrad3)' }} x='0' y='107.61' width='294.83' height='107.61' rx='53.81' ry='53.81' />
							<rect style={{ fill: 'url(#ecalLoadingGrad4)' }} x='51.86' y='107.61' width='206.06' height='107.61' rx='53.81' ry='53.81' transform='translate(309.78 322.83) rotate(-180)' />
							<rect style={{ fill: 'url(#ecalLoadingGrad5)' }} x='41.72' y='215.2' width='339.05' height='107.61' rx='53.81' ry='53.81' />
							<rect style={{ fill: 'url(#ecalLoadingGrad6)' }} x='132.56' y='215.2' width='248.22' height='107.61' rx='53.81' ry='53.81' transform='translate(513.34 538.02) rotate(180)' />
						</g>
                </svg>
        );
};

IconVibrantSVG.propTypes = {
        width: PropTypes.number,
        iconSize: PropTypes.number,
};

IconVibrantSVG.defaultProps = {
        width: 20,
        iconSize: DEFAULT_ICON_SIZE,
};

export default IconVibrantSVG;
